import { TConstants, TParameters } from '../types';
import { regExp } from '../types';

import $ip from'../../../pip/library/pi-ip/pi-ip.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

const QUERY_ASSIGNMENT = '=';
const QUERY_MARKER = '?';
const QUERY_JOIN = '&';

export function hasQuery(uri: string) {
  return uri.indexOf(QUERY_MARKER) >= 0;
}

export function getQuery(uri: string) {
  return f1.nth(1, uri.split(QUERY_MARKER));
}

export function expandParameterValues(parameters: TParameters, constants?: TConstants) {
  const cleanParameters: TParameters = {};

  Object.keys(parameters).forEach((key) => {
    const value = parameters[key];

    // FIXME we should not assign back to an input, this make the function impure
    // review all uses and refactor to assign only to `cleanedParams`
    //
    parameters[key] = Array.isArray(parameters[key])
      ? (value as string[]).map((str) => $ip.constants.read(str, constants))
      : $ip.constants.read(value as string, constants);

    cleanParameters[$ip.constants.read(key, constants)] = parameters[key];
  });

  return cleanParameters;
}

export function serializeParameters(queryParameters: TParameters, constants?: TConstants) {
  const expandedParameters = expandParameterValues(queryParameters, constants);
  const queryParts = [];

  for (let param in expandedParameters) {
    const value = expandedParameters[param];

    param = encodeURIComponent(param);

    if (Array.isArray(value)) {
      for (let _v, i = 0, l = value.length; i < l; i++) {
        _v = value[i];
        if (_v != null) {
          queryParts.push(param + QUERY_ASSIGNMENT + encodeURIComponent(_v));
        }
      }
    } else if (value != null) {
      queryParts.push(param + QUERY_ASSIGNMENT + encodeURIComponent(value));
    } else {
      queryParts.push(param);
    }
  }
  return queryParts.join(QUERY_JOIN);
}

export function deserializeParameters(queryString: string): TParameters {
  const queryParameterString = hasQuery(queryString) ? getQuery(queryString) : queryString;
  const paramsArr = queryParameterString.length > 1 ? queryParameterString.split(QUERY_JOIN) : [];

  return paramsArr.reduce((acc: TParameters, param) => {
    const [key, value] = param.split(QUERY_ASSIGNMENT);

    const decodedValue = decodeURIComponent(value);
    const decodedKey = decodeURIComponent(key);

    if (acc[decodedKey]) {
      const promotedParameter: string[] = (acc[decodedKey] = Array.isArray(acc[decodedKey])
        ? (acc[decodedKey] as string[])
        : ([acc[decodedKey]] as string[]));

      promotedParameter.push(decodedValue);
    } else if (decodedKey) {
      acc[decodedKey] = decodedValue;
    }

    return acc;
  }, {});
}

/**
 * read query parameters after the `?`
 */
export function readQueryParameters(v: string) {
  if (v.indexOf('?') < 0) {
    return {};
  }

  const queryParameterString = f1.nth(1, v.split('?'));
  return queryParameterString ? deserializeParameters(queryParameterString) : {};
}

export function writeQueryParameters(uri: string, parameterList: string[], parameters: TParameters) {
  const queryParameters = f1.pick(f1.difference(parameterList, f1.keys(parameters)), parameters);
  const existingQueryParameters = deserializeParameters(uri || '') || {};
  const exposeQueryParameters = Object.assign(existingQueryParameters, queryParameters);

  return serializeParameters(f1.compact(exposeQueryParameters));
}

/**
 * read route parameters
 */
export function readRouteParameters(uri: string) {
  return f1.map(
    f1.pipe([f1.nth(0), f1.cut(1, (undefined as unknown) as number)]),
    f1.matchAll(regExp.routeParameters, uri)
  );
}

/**
 *
 */
export function writeRouteParameters(uri: string, parameterList: string[], parameters: TParameters) {
  const routeParameters = f1.pick(parameterList, parameters);
  return uri.replace(regExp.routeParameters, (varMatch, key) => {
    const value = routeParameters[key];

    return `${value != null ? value : `!-${varMatch}-!`}`;
  });
}
